export const jsonTransform = {
  output: e => e,
  input: v => (typeof v === 'object' ? JSON.stringify(v) : v),
};

export const numberTransform = {
  output: e => {
    e.target.value = Number(e.target.value);
    return e;
  },
  input: v => Number(v),
};
